
export const RentFormHeader = ({text}) => {
    return (   
        <h2 className="text-2xl font-bold mb-5 text-left text-gray-800 ">
       {text}
      </h2>
    )
  }